import { useSsrAdapter as A } from "./highrise721.mjs";
import { inject as R, onBeforeMount as x, computed as B } from "vue";
import D from "./highrise1444.mjs";
import { configProviderInjectionKey as K } from "./highrise1066.mjs";
import { cssrAnchorMetaName as v } from "./highrise1445.mjs";
import m from "./highrise1183.mjs";
function G(n) {
  return n;
}
function _(n, t, d, i, p, l) {
  const s = A(), e = R(K, null);
  if (d) {
    const o = () => {
      const r = l == null ? void 0 : l.value;
      d.mount({
        id: r === void 0 ? t : r + t,
        head: !0,
        props: {
          bPrefix: r ? `.${r}-` : void 0
        },
        anchorMetaName: v,
        ssr: s,
        parent: e == null ? void 0 : e.styleMountTarget
      }), e != null && e.preflightStyleDisabled || D.mount({
        id: "n-global",
        head: !0,
        anchorMetaName: v,
        ssr: s,
        parent: e == null ? void 0 : e.styleMountTarget
      });
    };
    s ? o() : x(o);
  }
  return B(() => {
    var o;
    const {
      theme: {
        common: r,
        self: g,
        peers: b = {}
      } = {},
      themeOverrides: f = {},
      builtinThemeOverrides: u = {}
    } = p, {
      common: O,
      peers: h
    } = f, {
      common: S = void 0,
      [n]: {
        common: C = void 0,
        self: T = void 0,
        peers: M = {}
      } = {}
    } = (e == null ? void 0 : e.mergedThemeRef.value) || {}, {
      common: j = void 0,
      [n]: a = {}
    } = (e == null ? void 0 : e.mergedThemeOverridesRef.value) || {}, {
      common: y,
      peers: N = {}
    } = a, c = m({}, r || C || S || i.common, j, y, O), P = m(
      // {}, executed every time, no need for empty obj
      (o = g || T || i.self) === null || o === void 0 ? void 0 : o(c),
      u,
      a,
      f
    );
    return {
      common: c,
      self: P,
      peers: m({}, i.peers, M, b),
      peerOverrides: m({}, u.peers, N, h)
    };
  });
}
_.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
export {
  G as createTheme,
  _ as default
};
